import { Component, Input, OnDestroy } from '@angular/core';
import { DownloadService } from '../../../../shared/shared-services/download/download.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SchedJobsService } from '../../../ss-sched/services/jobs.service';
import { HttpResponse } from '@angular/common/http';
import {extractFilename} from '../../../../shared/utils/http-header.utils';

@Component({
  selector: 'prism-scheduler-file-download',
  templateUrl: './scheduler-file-download.component.html',
  styleUrls: ['./scheduler-file-download.component.scss']
})
export class SchedulerFileDownloadComponent implements OnDestroy{
    @Input() jobId: string;
    @Input() docId: string;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(
        private jobsService: SchedJobsService,
        private downloadService: DownloadService,
    ) {}

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    protected downloadFile(): void {
      this.jobsService.downloadJobDoc(this.jobId, this.docId)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(response => {
                const fileName = extractFilename(
                  response,
                  `JOB_${this.jobId}_${this.docId}.pdf`
                );
                this.downloadService.download(response.body, fileName);
            });
    }
}
